/* eslint-disable @typescript-eslint/no-unused-vars */
import { DashboardButtonType, DashboardButtonBehaviour } from '../../gen-src/preslayer/Enums';
import { ButtonZoneTelemetryInterface } from './ButtonZoneTelemetryInterface';

export class IgnoreButtonZoneTelemetry implements ButtonZoneTelemetryInterface {
  public logButtonActionInvoked(
    isAuthoring: boolean,
    clickType: string,
    buttonType: DashboardButtonType,
    buttonBehavior: DashboardButtonBehaviour
  ): void {
    return;
  }

  public logOpenButtonConfigDialogInvoked(
    clickType: string,
    buttonType: DashboardButtonType,
    buttonBehavior: DashboardButtonBehaviour
  ): void {
    return;
  }

  public logOpenButtonPermissionsErrorDialogInvoked(
    clickType: string,
    buttonType: DashboardButtonType,
    buttonBehavior: DashboardButtonBehaviour
  ): void {
    return;
  }
}
